import {
  createBrowserRouter,
  redirect,
  RouterProvider,
} from "react-router-dom";
import type { LazyRouteFunction, RouteObject } from "react-router-dom";
import { store, isLoginAtom } from "src/atoms/authAtom";
import { LazyExoticComponent } from "react";
import ErrorFallback from "src/pages/ErrorFallback";

type LazyArg0 = Promise<{ default: React.FC }>;

type LazyFactoryT = (arg0: LazyArg0) => Promise<{
  Component: React.FC;
}>;

const LazyFactory: LazyFactoryT = async (lazyComponent) => {
  const component = await lazyComponent;
  return { Component: component.default };
};

const Login = async () =>
  LazyFactory((await import("src/pages/Login")) as unknown as LazyArg0);
const Chat = async () =>
  LazyFactory((await import("src/pages/Chat")) as unknown as LazyArg0);
const About = async () =>
  LazyFactory((await import("src/pages/About")) as unknown as LazyArg0);
const Profile = async () =>
  await LazyFactory((await import("src/pages/Profile")) as unknown as LazyArg0);
const RouterWrapper = async () =>
  await LazyFactory((await import("./RouterWarpper")) as unknown as LazyArg0);

const mainRedirect = async () =>
  store.get(isLoginAtom) ? redirect("/chat") : redirect("/login");

const loginRedirect = async () => store.get(isLoginAtom) && redirect("/chat");
const shoudlLoginRedirect = async () => {
  return !store.get(isLoginAtom) && redirect("/login");
};

const authRouts: RouteObject[] = [
  {
    path: "/",
    lazy: RouterWrapper,
    ErrorBoundary: ErrorFallback,
    children: [
      {
        index: true,
        loader: mainRedirect,
      },
      {
        path: "/login",

        lazy: Login,
        loader: loginRedirect,
      },

      {
        path: "/chat",
        lazy: Chat,
        loader: shoudlLoginRedirect,
      },
      {
        path: "/about",
        lazy: About,
        loader: shoudlLoginRedirect,
      },
      {
        path: "/profile",
        lazy: Profile,
        loader: shoudlLoginRedirect,
      },
    ],
  },
];

export default createBrowserRouter(authRouts);
